angular.module("app").controller("AddEditSkinGameWinnersPageController", [
    '$scope',
    'preloadedSkinGames',
    'preloadedWinnerData',
    'casinoGameService',
    'errorHandler',
    'logger',
    function ($scope, preloadedSkinGames, preloadedWinnerData, casinoGameService, errorHandler, logger) {
        var init,
            editMode = !!preloadedWinnerData;


        (init = function (imidiatly, winnerData) {
            $scope.winnerData = editMode ? angular.copy(winnerData) : {
                desc: "",
                amount: "",
                userName: "",
                game_skin_id: ""
            };

            !winnerData && (!imidiatly && !!$scope.add_winner_form && $scope.add_winner_form.$setPristine());


            !imidiatly && (!editMode && $scope.$broadcast("force:reset:editor"));
        })(true, preloadedWinnerData);

        $scope.tooltip = {
            userName: "",
            amount: "",
            skinId: ""
        };

        $scope.preloadedSkinGames = angular.copy(preloadedSkinGames);

        $scope.save = function () {
            casinoGameService[editMode ? 'editGameSkinWinner' : 'createGameSkinWinner']({gameSkinWinner: angular.copy($scope.winnerData)}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("Winner has been successfully saved");
                        init(false, editMode ? angular.copy($scope.winnerData) : undefined);
                    } else {
                        errorHandler(response.message)
                    }

                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

    }
]);